import { api } from '../common/api'

export const getLoginSp = (params: Pick<AllParams, 'usrId'>) =>
  api.get<{
    // 头像
    image: string
    // 登陆请求流水号
    lgnId: string

    scrt: string
    // 用户名
    name: string
    email?: string
    // security phrase
    scrtPhr: 'Example Phrase'
    tel?: null
    token?: null
    userId?: 'TestName001'
  }>('/customer/logon/sp', { params, hideMsg: true })

export const loginSubmit = (params: Pick<AllParams, 'lgnId' | 'pwd'>) =>
  api.post<{
    userId: string
    scrtPhr: string
    tel: string
    image: string
    token: string
    lastLogonTime: string
    sex: 'male' | 'female'
  }>('/customer/logon/lgn', params,  { hideMsg: true, })
